var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "10px",
    viewBox: "0 0 9 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "65634372-75AA-4A6C-9E36-0C60F96F0012") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text-area-form-error",
    transform: "translate(-279.000000, -40.000000)",
    fillRule: "nonzero",
    stroke: "#FF5858",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(283.778175, 44.778175) rotate(-315.000000) translate(-283.778175, -44.778175) translate(278.278175, 39.278175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.9453125,5.58984375 L10.1816406,5.58984375",
    id: "Path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.9453125,5.58984375 L10.1816406,5.58984375",
    id: "Path-3",
    transform: "translate(5.563477, 5.589844) rotate(-90.000000) translate(-5.563477, -5.589844) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/cross-mark.7870cf7698dbc413e2c958b290c04ff5.svg";
export { ForwardRef as ReactComponent };